import React, { useCallback, useEffect } from 'react';
import {
  StyleSheet,
  Image,
  View,
  TouchableOpacity,
  Dimensions,
  Platform,
} from 'react-native';

import {observer} from 'mobx-react';
import {useFocusEffect, useNavigation, useRoute} from '@react-navigation/native';

import {SVGIcon, RNEText} from '../../components';

import {LogoContrast, LogoLight} from './../../images/Image';

import useStores from '../../stores/useStores';

import {colorPalette} from '../../../core/config/color.config';
import { NavigationKey } from '../../navigations/config';
import { useGetAccount } from '../../server/react-query/useAccount';
import { width, height, totalSize } from 'react-native-dimension';

interface HeaderProfileLeftProps {
  hasBack?: boolean;
  inProfileScreen?: boolean;
  isLogoContrast?: boolean;
}

const HeaderProfileLeft = (props: HeaderProfileLeftProps) => {
  const {patientProfileStore} = useStores();
  const navigation = useNavigation();
  const route = useRoute();
  const {authStore} = useStores();
  const activeProfile = patientProfileStore.activeProfileData;

  const [userProfileImg, setUserProfileImg] = React.useState<string | null>(null);

  const {data, refetch} = useGetAccount();

  useEffect(()=>{
    console.log(data?.photo?.url,'data?.photo?.url')
    if(data?.photo?.url){
      setUserProfileImg(data?.photo.url);
    }else{
      setUserProfileImg(null);
    }

  },[data]);

   useFocusEffect(
      useCallback(() => {
        if (Platform.OS !== 'web') {
          refetch();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
      }, []),
    );

  const onBackClick = () => {
    if (navigation.canGoBack()) {
      navigation.goBack();
    }
  };

  const renderProfileOrLogo = ({ inProfileScreen, isLogoContrast, hasBack }, activeProfile) => {

    return inProfileScreen ? (
      <View>
        <Image
          source={isLogoContrast ? LogoContrast : LogoLight}
          style={mobileStyles.logo}
        />
      </View>
    ) : (
      <View style={mobileStyles.profileContainer}>
        <View style={mobileStyles.profilePhoto}>
          {userProfileImg ? (
            <Image
              source={{ uri: userProfileImg }}
              style={mobileStyles.imageStyle}
            />
          ) : (
            <SVGIcon name="user" size={20} />
          )}
        </View>
        <RNEText
          label={`${activeProfile?.firstName ?? ''} ${activeProfile?.lastName ?? ''}`}
          variant="button"
          color="primary"
          // weight="bold"
          numberOfLines={1}
          style={{
            paddingHorizontal: 12,
            fontSize:totalSize(1.8),
            fontFamily:'Quicksand-Bold',
            width: Dimensions.get('screen').width - (hasBack ? 180 : 150),
          }}
        />
      </View>
    );
  };

  return (
    <View accessibilityRole="button" style={mobileStyles.mainContainer}>
      {props.hasBack && (
        <TouchableOpacity activeOpacity={0.75} onPress={onBackClick}>
          <View style={mobileStyles.backContainer}>
            <SVGIcon name="left-gray" size={20} />
          </View>
        </TouchableOpacity>
      )}

    {
      authStore.auth?.user.userRole !== 'practitioner' && (
        renderProfileOrLogo(props, activeProfile)
      )
    } 

    {
      (authStore.auth?.user.userRole === 'practitioner' && route.name !== NavigationKey.DOCTOR_SCREEN_LANDING) && (
        renderProfileOrLogo(props, activeProfile)
      )
    }
    </View>
  );
};

export default observer(HeaderProfileLeft);

const mobileStyles = StyleSheet.create({
  mainContainer: {
    paddingHorizontal: Platform.OS === 'android' ? 20 : totalSize(1),
    flexDirection: 'row',
    alignItems: 'center',
  },
  backContainer: {
    marginRight: 16,
  },
  logo: {
    width: 120,
    height: 40,
    position: 'relative',
  },
  profileContainer: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  profilePhoto: {
    borderRadius: 50,
    borderWidth: 1,
    borderColor: colorPalette.primary,
    width: width(10),
    height: width(10),
    alignItems: 'center',
    justifyContent: 'center',
  },
  imageStyle: {
    height: width(10),
    width: width(10),
    borderRadius: 100,
    borderWidth: 1,
    borderColor: colorPalette.primary,
  },
});
